<template>
  <MetricView view-name="home" />
</template>

<script lang="ts" setup>
import MetricView from '@/components/MetricView.vue';
</script>
